import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-matrix-joint-id',
    templateUrl: './matrix-joint-id.component.html',
    styleUrls: ['./matrix-joint-id.component.scss'],
})
export class MatrixJointIdComponent {
    @Input() form: UntypedFormGroup;
}
